module.exports = __webpack_public_path__ + "static/media/20.932f9ab6.jpg";